/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-unsafe-storage */
import PortalIdParser from 'PortalIdParser';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ExternalLinkIcon } from 'foundations-assets/icons/components/ExternalLinkIcon';
import { PlayerPlayIcon } from 'foundations-assets/icons/components/PlayerPlayIcon';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import UsageTracker from '../../utils/UsageTracker';
// @ts-expect-error Could not find a declaration file for module
import { getIsEnrolledInGettingStarted } from '../../actions/GettingStartedActions';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';

// @ts-expect-error Could not find a declaration file for module
import { getAcademyToSoftwareShowTooltip } from '../../selectors/academyToSoftwareSelectors';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error Could not find a declaration file for module
import { hideTooltip } from '../../actions/AcademyToSoftware';
import { useHomepageUrl } from '../../features/navigation';
import { useIsPaidAccount } from '../../hooks/productsHooks';
import HubSpotLogo from 'academy-common-lib/components/icon/HubSpotLogo';
import { Link } from 'foundations-components/transitional/components/Link';
import { SkeletonBlock, SkeletonWrapper } from '../../components/Skeletons/subcomponents/Skeleton';
// @ts-expect-error Could not find a declaration file for module
import SafeStorage from 'SafeStorage';
import { UserAttributeKeys } from '../../features/userAttributes';
import { useUserAttribute } from '../../features/userAttributes/userAttributesQueries';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { View } from 'foundations-components/transitional/components/View';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SoftwareDesirabilityButton = ({
  setModalOpen,
  use = 'button'
}) => {
  const {
    homepage: homepageUrl
  } = useHomepageUrl();
  const [isPaidAccount, isPaidAccountRequesting] = useIsPaidAccount();
  const dispatch = useDispatch();
  const {
    isMobileNavbar
  } = useMediaQuery();
  const isEnrolled = useSelector(state => state.gettingStarted.isEnrolledInGettingStarted);
  const isEnrolledRequesting = useSelector(state => state.gettingStarted.isGetIsEnrolledRequesting);
  const isEnrolledFetchedOnce = useSelector(state => state.gettingStarted.hasFetchedOnce);
  const showTooltip = useSelector(getAcademyToSoftwareShowTooltip);
  const isLoading = isPaidAccountRequesting || !isPaidAccount && isEnrolledRequesting;
  const localItem = SafeStorage.getItem('force_is_enrolled_in_user_guide');
  const forceIsFreeAccount = SafeStorage.getItem('force_is_free_account');
  const enrollLocalOverride = localItem !== null ? JSON.parse(localItem) : null;
  const isEnrolledOverridable = enrollLocalOverride !== null ? enrollLocalOverride : isEnrolled;
  const shouldRedirectToProductHomepage = isPaidAccount && !forceIsFreeAccount && !!homepageUrl;
  const isEnrolledOrPaidWithHomepageOverridable = enrollLocalOverride !== null ? enrollLocalOverride : isEnrolled || shouldRedirectToProductHomepage;
  const {
    setUserAttribute: setHasSeenCloseTooltip
  } = useUserAttribute(UserAttributeKeys.HAS_SEEN_CLOSE_TOOLTIP);
  const hideSoftwareButton = use === 'button' && isMobileNavbar;
  useEffect(() => {
    if (!isEnrolledFetchedOnce) {
      dispatch(getIsEnrolledInGettingStarted());
    }
  }, [dispatch, isEnrolledFetchedOnce]);
  const onClick = () => {
    if (shouldRedirectToProductHomepage) {
      window.open(homepageUrl, '_blank');
    } else if (isEnrolledOverridable) {
      window.open(`/user-guide/${PortalIdParser.get()}`, '_blank');
    } else {
      setModalOpen(true);
    }
    UsageTracker.track('interaction', {
      action: 'academy-to-software-button-clicked',
      isEnrolledOverridable,
      isPaidAccount: Boolean(isPaidAccount),
      homepageUrl,
      buttonStyle: use,
      whichButton: 'cta'
    });
  };
  useEffect(() => {
    if (!isLoading) {
      UsageTracker.track('interaction', {
        action: 'academy-to-software-button-viewed',
        isEnrolledOverridable,
        isPaidAccount: Boolean(isPaidAccount),
        homepageUrl,
        buttonStyle: use,
        whichButton: 'cta'
      });
    }
  }, [homepageUrl, isEnrolledOverridable, isLoading, isPaidAccount, use]);
  const buttonContentAlignment = use === 'inline' ? isEnrolledOrPaidWithHomepageOverridable ? 'baseline' : 'start' : 'center';
  const dataAttributes = {
    'data-is-enrolled': isEnrolledOverridable,
    'data-is-enrolled-or-paid-with-homepage': isEnrolledOrPaidWithHomepageOverridable,
    'data-is-paid': isPaidAccount,
    'data-test-id': 'academy-to-software-desirability-button'
  };
  const renderLoadingContent = useCallback(() => {
    return use === 'inline-link' ? /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "-50",
      children: /*#__PURE__*/_jsx(SkeletonWrapper, {
        display: "block",
        height: "14px",
        opacity: 0.2,
        width: "100px",
        children: /*#__PURE__*/_jsx(SkeletonBlock, {
          height: "14px",
          width: "100%"
        })
      })
    }) : /*#__PURE__*/_jsx(LoadingSpinner, {
      layout: "inline",
      marginBlock: "-25 !important",
      marginInline: "500",
      size: "extra-small",
      use: "primary-white"
    });
  }, [use]);
  const renderButtonContent = useCallback(() => {
    return /*#__PURE__*/_jsxs(TFlex, {
      align: buttonContentAlignment,
      children: [use === 'inline-link' ? /*#__PURE__*/_jsx(Link, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `academyNav.softwareDesirability.inlineLink.${isEnrolledOrPaidWithHomepageOverridable ? 'enrolled' : 'notEnrolled'}`
        })
      }) : /*#__PURE__*/_jsx("div", {
        style: {
          transform: use === 'button' ? 'translateY(-2px)' : 'none'
        },
        children: /*#__PURE__*/_jsx(Text, {
          as: "h6",
          color: "text-primary-default",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: `academyNav.softwareDesirability.button.${isEnrolledOrPaidWithHomepageOverridable ? 'enrolled' : 'notEnrolled'}`,
            options: {
              hubspotTextLogo: /*#__PURE__*/_jsx(HubSpotLogo, {
                fontSize: "16px"
              })
            }
          })
        })
      }), isEnrolledOrPaidWithHomepageOverridable && /*#__PURE__*/_jsx(IconHolder, {
        color: "text-primary-default",
        icon: ExternalLinkIcon,
        paddingBlockStart: use === 'inline' ? '0' : '100',
        paddingInlineEnd: use === 'button' ? '100' : '0',
        paddingInlineStart: use === 'inline' ? '50' : '100'
      }), !isEnrolledOrPaidWithHomepageOverridable && use !== 'inline-link' && /*#__PURE__*/_jsx(IconCircle, {
        backgroundColor: "fill-accent-orange-default",
        borderWidth: "0",
        color: "text-primary-default",
        icon: PlayerPlayIcon,
        legacy: true,
        marginInlineEnd: "100",
        marginInlineStart: "300",
        size: "100"
      })]
    });
  }, [buttonContentAlignment, isEnrolledOrPaidWithHomepageOverridable, use]);
  if (hideSoftwareButton) return null;
  if (use === 'inline') {
    return /*#__PURE__*/_jsx(Link, Object.assign({}, dataAttributes, {
      onClick: onClick,
      use: "unstyled",
      children: isLoading ? renderLoadingContent() : renderButtonContent()
    }));
  }
  return /*#__PURE__*/_jsx(Popover, {
    content: /*#__PURE__*/_jsxs(TFlex, {
      flexDirection: "column",
      paddingBlock: "200",
      paddingInline: "400",
      children: [/*#__PURE__*/_jsx(Text, {
        color: "text-primary-default",
        typography: "detail-200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyNav.softwareDesirability.tooltip"
        })
      }), /*#__PURE__*/_jsx(Button, {
        marginBlockEnd: "50",
        marginBlockStart: "200",
        onClick: () => {
          dispatch(hideTooltip());
          void setHasSeenCloseTooltip(true);
          UsageTracker.track('interaction', {
            action: 'academy-to-software-tooltip-dismissed'
          });
        },
        size: "sm",
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyNav.softwareDesirability.gotItButton"
        })
      })]
    }),
    inlineSize: "320px",
    open: showTooltip,
    placement: "bottom left",
    use: "tooltip",
    children: /*#__PURE__*/_jsx(Button, Object.assign({}, dataAttributes, {
      onClick: onClick,
      paddingBlock: '100',
      paddingInlineEnd: use === 'button' ? '300' : '0',
      paddingInlineStart: use === 'button' ? '500' : '0',
      size: 'sm',
      use: use === 'button' ? 'transparent' : 'unstyled',
      children: isLoading ? renderLoadingContent() : renderButtonContent()
    }))
  });
};
export default SoftwareDesirabilityButton;